import { useDataLoader } from "2g-hooks/fetch";

import { ADMIN } from "b2b/api/paths";

import { isEmpty } from "2g-utils-common";

export default function useSmlouva({ id }) {
  return useDataLoader({
    url: ADMIN.smlouva(id),
    method: "get",
    lazy: isEmpty(id)
  });
}
